import _ from 'lodash';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import user from '../../helpers/user';
import { IBookmarkService } from '@intigral/domain/lib/application/services/BookmarkService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateTaContinueWatchingFeeds } from '../data/taFeedQueryKeys';
import { rethrowAsError } from '../../utils/asyncError';

export const useDeleteBookmarkMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ bookmark, src }: { bookmark: any; src?: string }) => {
            try {
                const assetId = bookmark.category === 'VOD' ? bookmark.mediaId : bookmark.listingId;
                const paId = bookmark.category === 'VOD' ? bookmark.Id : bookmark.paId;
                const bookmarkService = await container.resolve<IBookmarkService>(DI.SERVICES.IBookmarkService);
                await bookmarkService.deleteBookmark(
                    user.getAPIKey(),
                    user.getProfile()?.profileGuid,
                    user.getUserToken(),
                    user.getIdentityToken(),
                    assetId,
                    paId,
                    src
                );
                return {
                    ItemToDelete: bookmark,
                };
            } catch (error) {
                rethrowAsError(error, 'Failed to delete bookmark');
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['profiles', 'bookmarks'],
            });
            queryClient.invalidateQueries({
                queryKey: ['profiles', 'detailed-bookmarks'],
            });
            invalidateTaContinueWatchingFeeds(queryClient);
        },
    });
};
